export default __webpack_public_path__ + "static/media/contactusAvatar.6f028a69.svg";